<template>
    <div>
        <button
            class="btn btn-sm is-ghost align-top px-2xl"
            @click="$modal.show(orderCommentModalName)"
        >
            Orderkommentar
        </button>

        <adaptive-form-modal
            :name="orderCommentModalName"
            primary-button-text="Kommentera"
            primary-button-class="is-primary"
            title="Orderkommentar"
            :callback="commentWasStored"
            method="PATCH"
            :action="route('api.orders.comments.update', order)"
        >
            <textarea
                v-model="body"
                name="body"
                class="form-input"
                rows="5"
                required
            />
        </adaptive-form-modal>

        <adaptive-form-modal
            :name="deleteCommentModalName"
            primary-button-text="Ta bort kommentar"
            primary-button-class="is-danger"
            title="Ta bort orderkommentar"
            :callback="commentWasDeleted"
            method="DELETE"
            :action="route('api.orders.comments.destroy', order)"
        >
            <p>Är du helt säker på att du vill radera orderkommentaren?</p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    import OrderCommentBase from './OrderCommentBase';

    export default {
        extends: OrderCommentBase,
    };
</script>
